import React from 'react';

type ModalProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
};

const Modal: React.FC<ModalProps> = ({ open, onClose, title, children }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg max-w-xl w-full p-6 relative">
        {title && <div className="text-lg font-semibold mb-4  text-BADBlue">{title}</div>}
        <button
          className="absolute top-2 right-2 text-2xl text-BADGray hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
